module.exports = __webpack_public_path__ + "img/kaoshi.e95b888f.svg";